module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["添加学生"]), " ", _vm._h('span', {
    staticClass: "pull-right icon-right orange",
    on: {
      "click": function($event) {
        _vm.addStudent()
      }
    }
  }, ["提交"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', [_vm._h('p', {
    staticClass: "margin-15"
  }, ["红色“*”为必填项，请认真填写。"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix upload-head upload-pic"
  }, [_vm._h('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "method": "post",
      "name": "fileinfo"
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["上传头像"]), " ", _vm._h('span', {
    staticClass: "pull-right"
  }, [_vm._h('img', {
    attrs: {
      "src": _vm.imageAddress ? _vm.baseAcessPath + _vm.imageAddress : _vm.img_default,
      "width": "60",
      "height": "60"
    }
  })]), " ", (_vm.isAndroid) ? _vm._h('span', {
    staticClass: "upload-wrap",
    on: {
      "click": function($event) {
        _vm.capturePhoto();
      }
    }
  }) : _vm._h('span', {
    staticClass: "upload-wrap"
  }, [_vm._h('input', {
    attrs: {
      "type": "file",
      "name": "pic",
      "id": "pic",
      "accept": "image/*",
      "size": "1"
    },
    on: {
      "change": function($event) {
        _vm.updateImage()
      }
    }
  })]), " "])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["学生姓名："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentName),
      expression: "studentName"
    }],
    staticClass: "text-right font-14",
    attrs: {
      "type": "text",
      "placeholder": "请输入学生姓名"
    },
    domProps: {
      "value": _vm._s(_vm.studentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentName = $event.target.value
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix  group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["性别："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right clearfix checkbox-group"
  }, [_vm._h('cite', {
    staticClass: "pull-right img-checkbox",
    class: {
      'checked': _vm.sex == '女'
    },
    on: {
      "click": function($event) {
        _vm.sex = '女'
      }
    }
  }, ["女"]), " ", _vm._h('cite', {
    staticClass: "pull-right img-checkbox",
    class: {
      'checked': _vm.sex == '男'
    },
    on: {
      "click": function($event) {
        _vm.sex = '男'
      }
    }
  }, ["男"])])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        _vm.openPicker('picker')
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["出生年月："]), " ", _vm._h('span', {
    staticClass: "pull-right margin-x-15 gray font-12"
  }, [_vm._s(_vm.birthday ? _vm.birthday : '请选择')])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny hide"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getCurcheClassList()
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["编入班级："]), " ", _vm._h('span', {
    staticClass: "pull-right margin-x-15 gray font-12"
  }, [_vm._s(_vm.curcheClassName)])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getCurcheServiceList()
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["托管服务："]), " ", _vm._h('span', {
    staticClass: "pull-right margin-x-15 gray font-12"
  }, [_vm._s(_vm.curcheServiceName)])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["所在学校："]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.szxx),
      expression: "szxx"
    }],
    staticClass: "text-right font-14",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": _vm._s(_vm.szxx)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.szxx = $event.target.value
      }
    }
  })])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideSchoolGrade = false
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["年级："]), " ", _vm._h('span', {
    staticClass: "pull-right margin-x-15 gray font-12"
  }, [_vm._s(_vm.grade ? _vm.grade : '请选择')])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideSchoolClass = false
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["班级："]), " ", _vm._h('span', {
    staticClass: "pull-right margin-x-15 gray font-12"
  }, [_vm._s(_vm.className ? _vm.className + '班' : '请选择')])])])]), " ", _vm._h('span', {
    staticClass: "block margin-x-15 gray"
  }, ["家长信息"]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "clearfix group-txt img-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideParentRole = false
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["监护角色："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray margin-x-15 font-12"
  }, [_vm._s(_vm.parentRole ? _vm.parentRole : '请选择')])])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix group-txt"
  }, [_vm._h('span', {
    staticClass: "pull-left"
  }, ["手机号码："]), _vm._h('i', {
    staticClass: "red must"
  }, ["*"]), " ", _vm._h('span', {
    staticClass: "pull-right gray"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentPhone),
      expression: "parentPhone"
    }],
    staticClass: "text-right font-14",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": _vm._s(_vm.parentPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentPhone = _vm._n($event.target.value)
      }
    }
  })])])])])])]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideSetCurcheServiceDialog),
      expression: "!isHideSetCurcheServiceDialog"
    }],
    staticClass: "maskdiv"
  }, [_vm._h('div', {
    staticClass: "popover"
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [(_vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('p', ["该园点还未设置托管服务，请到“园点管理”处设置。"]) : _vm._h('p', ["该园点还未设置托管服务，请联系管理员到“园点管理”处设置。"]), " ", " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", (_vm.cookie_login_data.jobId == 1 || _vm.cookie_login_data.jobId == 2) ? _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('router-link', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    attrs: {
      "hre": "javascript:;",
      "to": {
        'path': '/curche/edit'
      }
    }
  }, ["去设置"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    attrs: {
      "hre": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.isHideSetCurcheServiceDialog = true
      }
    }
  }, ["以后再说"])])]) : _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-12 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    attrs: {
      "hre": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.isHideSetCurcheServiceDialog = true
      }
    }
  }, ["以后再说"])])]), " "])])]), " ", _vm._h('mt-popup', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popupVisebleTips),
      expression: "popupVisebleTips"
    }],
    attrs: {
      "position": "bottom"
    },
    domProps: {
      "value": (_vm.popupVisebleTips)
    },
    on: {
      "input": function($event) {
        _vm.popupVisebleTips = $event
      }
    }
  }, [_vm._h('div', [_vm._h('div', {
    staticClass: "padding-15"
  }, [_vm._h('p', {
    staticClass: "font-16 margin-15"
  }, ["温馨提示"]), " ", _vm._h('p', {
    staticClass: "font-12 margin-15 gray"
  }, ["手动添加的家长手机号为 ", _vm._h('span', {
    staticClass: "orange"
  }, ["“未激活”"]), " 状态，不能作为家长的登录账号，如果要为家长开通，请发邀请给家长申请开通哦！"])]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('span', {
    staticClass: "block text-center padding-15",
    on: {
      "click": function($event) {
        _vm.popupVisebleTips = false
      }
    }
  }, ["我知道了"])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideCurcheService),
      expression: "!isHideCurcheService"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideCurcheService = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["关联服务"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.curcheServiceList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          _vm.csId = item.csId, _vm.isHideCurcheService = true, _vm.curcheServiceName = item.serviceName + ' ' + item.currentServiceFee + '元/月'
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item.serviceName) + " " + _vm._s(item.currentServiceFee) + "元/月"]), " ", (item.csId == _vm.csId) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideCurcheClass),
      expression: "!isHideCurcheClass"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideCurcheClass = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["编入班级"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.curcheClassList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          _vm.classId = item.classId, _vm.curcheClassName = item.className, _vm.isHideCurcheClass = true
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item.className)]), " ", (item.classId == _vm.classId) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideSchoolGrade),
      expression: "!isHideSchoolGrade"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideSchoolGrade = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["选择年级"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.gradeList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          _vm.grade = item, _vm.isHideSchoolGrade = true
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item)]), " ", (item == _vm.grade) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideSchoolClass),
      expression: "!isHideSchoolClass"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideSchoolClass = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["选择班级"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((20), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          _vm.className = (item + 1), _vm.isHideSchoolClass = true
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item + 1) + "班"]), " ", (item + 1 == _vm.className) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })])])]), " ", " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideParentRole),
      expression: "!isHideParentRole"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideParentRole = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "slider",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('strong', {
    staticClass: "tit"
  }, ["监护角色"]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.parentRoleList), function(item) {
    return _vm._h('ul', [_vm._h('li', {
      on: {
        "click": function($event) {
          _vm.parentRole = item, _vm.isHideParentRole = true
        }
      }
    }, [_vm._h('div', {
      staticClass: "clearfix group-link"
    }, [_vm._h('span', {
      staticClass: "pull-left"
    }, [_vm._s(item)]), " ", (item == _vm.parentRole) ? [_vm._h('i', {
      staticClass: "pull-right img-checkbox checked"
    })] : [_vm._h('i', {
      staticClass: "pull-right img-checkbox"
    })], " "]), " ", _vm._h('div', {
      staticClass: "liner"
    })])])
  })])])]), " ", _vm._h('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "date",
      "year-format": "{value} 年",
      "month-format": "{value} 月",
      "date-format": "{value} 日",
      "start-date": _vm.pickerStartDate,
      "end-date": _vm.pickerEndDate
    },
    on: {
      "confirm": _vm.handleChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-6dfae632!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/student/StudentAdd.vue
// module id = 211
// module chunks = 1